import React from "react";
import {Icon} from "../core/Icon.jsx";
import {IconButton} from "../core/IconButton.jsx";

const TONES={
  info:{icon:"info",color:"var(--text-info)"},
  success:{icon:"check-circle-2",color:"var(--text-success)"},
  warning:{icon:"alert-triangle",color:"var(--text-warning)"},
  danger:{icon:"alert-circle",color:"var(--text-danger)"}
};

export function Toast({tone="info",title,message,onClose,style,...rest}){
  const t=TONES[tone];
  return (
    <div role="status" style={{display:"flex",gap:"12px",alignItems:"flex-start",width:"100%",maxWidth:380,
      padding:"12px 12px 12px 14px",background:"var(--surface-card)",border:"var(--border-default)",
      borderLeft:"2px solid "+t.color,borderRadius:"var(--radius-2)",boxShadow:"var(--shadow-pop)",...style}} {...rest}>
      <span style={{color:t.color,display:"inline-flex",marginTop:1}}><Icon name={t.icon} size={17} strokeAlign="middle"/></span>
      <div style={{flex:1}}>
        <div style={{fontFamily:"var(--font-display)",fontSize:"var(--text-sm)",fontWeight:"var(--weight-semibold)"}}>{title}</div>
        {message&&<div style={{fontSize:"var(--text-2xs)",color:"var(--fg-2)",marginTop:2}}>{message}</div>}
      </div>
      {onClose&&<IconButton icon="x" label="Cerrar" size="sm" onClick={onClose}/>}
    </div>
  );
}
